export default "__VITE_ASSET__D3L4xy7x__"